export function strokeWidth(style) {
    return currentStrokeWidths[style];
}
/*
 * Stroke Thickness Overriding
 */
let strokeWidthsForTheme = {
    s: {
        thicker: 4.0,
        thick: 3.0,
        default: 2.0,
        thin: 1.5,
        thinner: 1.0,
        liquid: 1.0,
    },
    m: {
        thicker: 6.0,
        thick: 4.0,
        default: 3.0,
        thin: 2.0,
        thinner: 1.5,
        liquid: 1.5,
    },
    l: {
        thicker: 8.0,
        thick: 5.0,
        default: 4.0,
        thin: 3.0,
        thinner: 2.0,
        liquid: 2.0,
    }
};
let currentStrokeWidths = strokeWidthsForTheme.m;
/** Call this to globally update thte current thickness theme */
export function setGloballyStrokeThicknessTheme(theme) {
    currentStrokeWidths = strokeWidthsForTheme[theme];
}
/** Returns an anchor of given name. First match is returned if there are multiple matches */
export function getFirstAnchorWithName(anchors, name) {
    for (const anchor of anchors) {
        if (anchor.name === name) {
            return anchor;
        }
    }
    return undefined;
}
